document.addEventListener('DOMContentLoaded', function() {
  // 1. SELECT THE MESSAGE ELEMENTS
  const messages = document.querySelectorAll('.promo-message');
  
  // Exit the script if no messages are found to prevent errors
  if (messages.length < 2) {
      // If there are 0 or 1 message, no cycling is needed.
      // We still add the 'active' class to ensure the single message is visible.
      if (messages.length === 1) {
          messages[0].classList.add('active');
      }
      return; 
  }
  
  let currentIndex = 0;
  // Set the duration for how long each message should be displayed (4 seconds)
  const cycleTime = 4000; // 4000 milliseconds = 4 seconds

  // Function to handle the rotation logic
  function cycleMessages() {
    // 2. FADE OUT: Remove the 'active' class from the currently visible message
    messages[currentIndex].classList.remove('active');

    // 3. CALCULATE NEXT INDEX: Move to the next index, using the modulo operator 
    // to loop back to the start (index 0) after the last message.
    currentIndex = (currentIndex + 1) % messages.length;

    // 4. FADE IN: Add the 'active' class to the new message
    messages[currentIndex].classList.add('active');
  }

  // 5. INITIAL STATE: Set the first message to active immediately upon page load
  messages[currentIndex].classList.add('active');

  // 6. START THE TIMER: Begin the repeating cycle at the defined interval
  setInterval(cycleMessages, cycleTime);
});